import { Component, Inject, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MawbService } from 'src/app/shared/services/mawb.service';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { ShipmentService } from 'src/app/shared/services/shipment.service';
import { BehaviourService } from 'src/app/shared/services/behaviour.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-link-pieces',
  templateUrl: './link-pieces.component.html',
  styleUrls: ['./link-pieces.component.scss'],
})
export class LinkPiecesComponent {
  piecesList: any;
  selectedCars: [];
  dataSource = new MatTableDataSource<any>();
  selection = new SelectionModel<any>(true, []);
  displayedColumns: string[] = [
    'select',
    'shipmentID',
    'PieceID',
    'ctryCode',
    'serviceCode',
    'pieceStatus',
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  selectedMAWB: any;
  selectedShipmentsDlink: any;
  selectedShipmentsLink: any;
  linkedShipments = [];
  unLinkedShipments = [];
  box_id_forPrint;
  palletID;
  shipmentID;
  linkDisable: boolean;
  pieceStatusExist: boolean;
  pieceLevelLabelPrint: boolean;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<LinkPiecesComponent>,
    private mawService: MawbService,
    private shipmentService: ShipmentService,
    private errorDialogService: ErrorDialogService,
    private behaviorService: BehaviourService,
    private router: Router
  ) {
    this.palletID = data.palletId;
    this.selectedMAWB = data.mawId;
    this.shipmentID = data.shipmentId;
    this.dataSource.data = data.pieces;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.pieceLevelLabelPrint = data.pieceLevelLabelPrint;
    if (this.pieceLevelLabelPrint) {
      if (data.pieces.every(item => item.status != undefined && item.status != '')) {
        this.checkPieceStatus(data.pieces);
      } else {
        this.pieceStatusExist = false;
      }
    } else {
      this.pieceStatusExist = false;
    }
    // this.pieceLevelLabelPrint
    //   ? data.pieces.every(item => item.status != undefined && item.status != '')
    //     ? this.checkPieceStatus(data.pieces)
    //     : (this.pieceStatusExist = false)
    //   : false;
  }

  isAllSelected() {
    this.selectedShipmentsDlink = this.selection.selected;
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.shipmentID + 1}`;
  }

  linkShipments() {
    const unLinkPieces = [];
    const unLinkShipments = [];
    if (this.selection.selected.length == 0) {
      return this.errorDialogService.openDialog('alert.selectPieceToLinkPallet', false);
    }
    unLinkPieces.push(...this.selection.selected.map(shipment => shipment.pieceID));
    unLinkShipments.push(...this.selection.selected.map(shipment => shipment.shipmentID));
    const unique = arr => [...new Set(arr)];
    const data = {
      palletID: this.palletID,
      pieces: unLinkPieces,
      shipments: unique(unLinkShipments),
      mawb: this.selectedMAWB,
    };
    this.mawService.linkPieces(data).subscribe((res: any) => {
      if (res.Errors.length > 0) {
        return this.errorDialogService.openDialog(res.Errors, false);
      }
      this.box_id_forPrint = '';
      this.getUnlinkedPieces();
    });
  }

  getUnlinkedPieces() {
    this.shipmentService.getPieceListWithShipmentId(this.shipmentID).subscribe({
      next: (data: any) => {
        const unlinkedPieces = data.filter(pieceData => pieceData.palletID == null);
        this.dataSource.data = unlinkedPieces;
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      },
      // error: error => {
      //   console.error('There was an error!', error);
      // },
    });
  }

  checkPieceStatus(data) {
    this.pieceStatusExist = true;
    this.linkDisable = data.some(item => item.status.toLowerCase() == 'Not Generated'.toLowerCase())
      ? true
      : false;
  }
  navToShipmentList(shipmentId) {
    this.dialogRef.close({
      shipmentId: shipmentId,
    });
    // this.dialogRef.close();
    // const data = {
    //   shipmentId: shipmentId,
    // };
    this.behaviorService.sendEvent(shipmentId);
    this.router.navigateByUrl('/shipment-list');
  }
}
